module.exports = __webpack_public_path__ + "static/media/SCR062.cf308291.mp3";